const tokenKey = 'CapacitorStorage.browser_auth_token';

export { tokenKey };

export function browserToken() {
    try {
        return localStorage.getItem(tokenKey);
    } catch (_) {
        return null;
    }
}

export async function hasValidBrowserSession() {
    const token = browserToken();
    if (!token) return false;

    try {
        const response = await fetch('/api/v1/user', {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
                'X-SportsDock-Client': 'browser',
            },
            cache: 'no-store',
        });

        return response.ok && browserToken() === token;
    } catch (_) {
        return false;
    }
}
